<template>
  <div class="view-community-topic">
    <page-header />

    <div class="px-4 px-lg-5">
      <div class="row">
        <div class="col-lg-3 col-sm-6 py-5 order-lg-1">
          <categories-list />
        </div>

        <div class="col-lg-3 col-sm-6 py-5 order-lg-3">
          <button
            class="btn btn-primary btn-block btn-strong rounded-pill"
            @click="addDialog = true"
          >
            <i class="fas fa-plus"></i> CRIAR TÓPICO
          </button>

          <top-comments v-if="topComments" />
          <hr class="my-4" style="border-color: rgba(255, 255, 255, 0.2);" />
          <search-users />
        </div>

        <div class="col-lg-6 py-5 order-lg-2">
          <action-dispatcher
            action="community/get"
            :parameters="$route.params.id"
            ref="commentsGet"
            :always-show-slot="!firstLoad"
            @success="firstLoad = false"
          >
            <comment
              :comment="comment"
              class="my-0"
              @edit="openEdit"
              @remove="openRemove"
              @reply="reply"
            />
          </action-dispatcher>
        </div>
      </div>
    </div>

    <b-modal v-model="addDialog" hide-header hide-footer centered>
      <comments-form key="d" @success="refresh(true)" />
    </b-modal>

    <b-modal v-model="replyDialog" hide-header hide-footer centered>
      <comments-form
        key="e"
        @success="refresh(true)"
        :parent="selectedComment"
      />
    </b-modal>

    <b-modal v-model="editDialog" hide-header hide-footer centered>
      <comments-form
        key="f"
        @success="refresh(true)"
        :comment="selectedComment"
      />
    </b-modal>

    <confirmation
      v-model="removeDialog"
      @confirm="remove"
      text="Tem certeza que deseja remover comentário?"
      confirm-button-text="Remover"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Community from "./Community";
import TopComments from "@/components/community/TopComments";
import SearchUsers from "@/components/community/SearchUsers";
import CategoriesList from "@/components/community/CategoriesList";

export default {
  mixins: [Community],
  components: { TopComments, SearchUsers, CategoriesList },
  data() {
    return {
      topComments: true
    };
  },
  computed: {
    ...mapState("community", ["comment"])
  },
  methods: {
    refreshTopComments() {
      this.topComments = false;
      setTimeout(() => {
        this.topComments = true;
      }, 1);
    }
  }
};
</script>
